import React, { useState } from "react";
import "./GameHeader.scss";
import { Nav, Navbar } from "react-bootstrap";
// imports Image
import MenuIcon from "assets/images/Menu.svg";
import BrandLogo from "assets/images/Logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import BurgerMenu from "common/components/BurgerMenu";
import NavDropdown from "common/components/NavDropdown/NavDropdown";

interface Props {
  style?: React.CSSProperties | undefined;
  handleClickOpenLeftMenu?: () => void;
}

function GameHeader({ style, handleClickOpenLeftMenu }: Props) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const biddingTabs = [
    { key: "10", label: "תחילת הדרך", path: "/by_hand_exercise?type=10" },
    { key: "20", label: "מכרז התקפי", path: "/by_hand_exercise?type=20" },
    { key: "30", label: "מכרז תחרותי", path: "/by_hand_exercise?type=30" },
    { key: "40", label: "קונבנציות", path: "/by_hand_exercise?type=40" },
    { key: "50", label: "2 על 1", path: "/by_hand_exercise?type=50" },
    { key: "60", label: "תרגול משולב", path: "/by_hand_exercise?type=60" },
    { key: "70", label: "תרגול חבילות", path: "/by_hand_exercise?type=70" }
  ];

  const handPlayTabs = [
    { key: "handPlay", label: "תרגול לפי קורסים", path: "/by_hand_play_exercise?type=handPlay" },
    { key: "practice", label: "תרגול לפי טכניקה", path: "/by_hand_play_exercise?type=practice" },
    { key: "tricks", label: "תרגול לקיחות", path: "/by_hand_play_exercise?type=tricks" },
    // { key: "miniBridge", label: "מיני ברידג'", path: "/by_hand_play_exercise?type=miniBridge" }
  ];

  const defenseTabs = [
    { key: "deffense", label: "תרגול לפי קורסים", path: "/by_deffence_exercise?type=deffense" },
    { key: "practice", label: "תרגול לפי טכניקה", path: "/by_deffence_exercise?type=practice" },
    { key: "defLead", label: "תרגול הובלות", path: "/by_deffence_exercise?type=defLead" }
  ];

  // Check if routes are active
  const isBiddingActive =
    location.pathname.indexOf("by_hand_exercise") !== -1 ||
    location.pathname.indexOf("bidding") !== -1;

  const isHandPlayActive =
    (location.pathname.indexOf("by_hand_play_exercise") !== -1 ||
      location.pathname.indexOf("hand_play") !== -1) &&
    location.search !== "?type=tricks";

  const isDefenseActive =
    (location.pathname.indexOf("by_deffence_exercise") !== -1 ||
      location.pathname.indexOf("deffense_play") !== -1) &&
    location.search !== "?type=defLead";

  return (
    <>
      <header className="game-header" style={style}>
        <div className="logo-menu-icon-wrapper">
          <a onClick={handleClickOpenLeftMenu}>
            <img src={MenuIcon} alt="" onClick={() => setIsOpen(!isOpen)} />
          </a>
          <Navbar.Brand onClick={() => navigate("/main_page")} style={{ cursor: "pointer" }}>
            <img src={BrandLogo} alt="" style={{ width: 192, height: 47 }} />
          </Navbar.Brand>
        </div>
        <div className="nav-header">
          <Nav className="navbar-main-header">
            <NavDropdown
              title="הכרזות"
              tabs={biddingTabs}
              basePath="/by_hand_exercise"
              isActive={isBiddingActive}
            />
            <NavDropdown
              title="משחק יד"
              tabs={handPlayTabs}
              basePath="/by_hand_play_exercise"
              isActive={isHandPlayActive}
            />
            <NavDropdown
              title="הגנה"
              tabs={defenseTabs}
              basePath="/by_deffence_exercise"
              isActive={isDefenseActive}
            />
            <Nav.Link
              style={{ cursor: "pointer" }}
              className={`nav-item ${
                location.pathname.indexOf("by_summary") !== -1 ? "nav-item-header-active" : ""
              }`}
              onClick={() => navigate("/by_summary", { state: { resetModal: Date.now() } })}>
              תקצירים
            </Nav.Link>
            {/*<Nav.Link*/}
            {/*  className={`nav-item ${*/}
            {/*    location.pathname.indexOf("lessons") !== -1 ? "nav-item-header-active" : ""*/}
            {/*  }`}*/}
            {/*  onClick={() => navigate("/lessons")}>*/}
            {/*  שיעורים*/}
            {/*</Nav.Link>*/}
          </Nav>
          <Nav className="navbar-main-header">
            <Nav.Link
              className={`nav-item ${
                location.pathname.indexOf("student_folder") !== -1 ? "nav-item-header-active" : ""
              }`}
              onClick={() => navigate("/student_folder")}>
              תיק תלמיד
            </Nav.Link>
            <Nav.Link
              className={`nav-item ${
                location.pathname.indexOf("educational_video") !== -1
                  ? "nav-item-header-active"
                  : ""
              }`}
              onClick={() => navigate("/educational_video")}>
              הדרכות
            </Nav.Link>
            <button
              className="btn-md btn-md-primary"
              // style={{ opacity: isPricingButtonHidden ? 0 : 100 }}
              onClick={() => navigate("/payment")}>
              לרכישת מנוי
            </button>
          </Nav>
        </div>
      </header>
      <BurgerMenu viewOpenLeftMenu={isOpen} handleClickCloseLeftMenu={() => setIsOpen(false)} />
    </>
  );
}

export default GameHeader;
